import Lottie from "lottie-react";
import React from "react";
import { payment_loading } from "../../Lottie/payment";

function PaymentLoader() {
  return (
    <div className="absolute w-full h-full left-0 top-0 bg-white backdrop-blur-[2px] bg-opacity-10 flex justify-center items-center">
      <Lottie
        className="md:w-[250px] w-[200px]"
        animationData={payment_loading}
        loop={true}
      />
    </div>
  );
}

export default PaymentLoader;
